import React, { useState, useContext, useEffect } from "react";
import { Formik, Form } from "formik";
import Modal from "../../../Ui/Modal";
import { Property } from "../../../../service";
import ButtonComponent from "../../../Ui/Button";
import FormField from "../../../utils/FormFileds";
import useApiHandler from "../../../hooks/ApiHandler";
import { UserContext } from "../../../context/UserContext";
import { statusColors, statusDots } from "../../../constant/Home/Common";
import {
  tenantFieldConfigPropertyDetails,
  familyMemberFieldConfigPropertyDetails,
} from "../../../constant/Home/Properties";
import { formatDate } from "../../../utils/FormatDate";
import { formatIssueAndSubIssue } from "../../../utils/utils";

// Local helper to display enum-like statuses in a human-readable form
const humanizeStatus = (value) => {
  if (!value || typeof value !== "string") return "";
  return value
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
};

const ViewDetails = ({
  setModalState,
  propertyId,

  property,
  setCurrentSelectedData,
  setPropertyId,
}) => {
  const { userData } = useContext(UserContext);
  const { callApi, loading } = useApiHandler();
  const [propertyData, setPropertyData] = useState(null);
  const [selectedTenantIndex, setSelectedTenantIndex] = useState(0);
  const [selectedFamilyIndex, setSelectedFamilyIndex] = useState(0);

  const handleClose = () => {
    setModalState("");
    setPropertyId(null);
  };

  const fetchpropertyId = () => {
    if (propertyId) {
      callApi(() => Property.getPropertyById(propertyId), {
        onSuccess: (res) => {
          console.log("property data", res.data);
          setPropertyData(res.data);
        },
        onError: (error) => {
          console.error("Error fetching property details:", error);
        },
        errorMessage: "Failed to fetch property details",
      });
    }
  };

  useEffect(() => {
    fetchpropertyId();
  }, [propertyId]);

  const handleTenantChange = (event) => {
    const newIndex = parseInt(event.target.value);
    setSelectedTenantIndex(newIndex);
  };
  const handleFamilyChange = (event) => {
    const newIndex = parseInt(event.target.value);
    setSelectedFamilyIndex(newIndex);
  };

  const getInitialValues = () => {
    if (propertyData?.tenants && propertyData?.tenants.length > 0) {
      const selectedTenant = propertyData?.tenants[selectedTenantIndex];
      const selectedUnit =
        selectedTenant.units && selectedTenant.units.length > 0
          ? selectedTenant.units[0]
          : null;

      return {
        tenant_unit: selectedUnit ? `Unit ${selectedUnit.unit_apt}` : "",
        tenant_phone: selectedTenant.phone_number || "",
        tenant_email: selectedTenant.email || "",
      };
    }
    return {
      tenant_unit: "",
      tenant_phone: "",
      tenant_email: "",
    };
  };
  const getFamilyInitialValues = () => {
    if (
      propertyData?.family_members &&
      propertyData?.family_members.length > 0
    ) {
      const selectedMember = propertyData?.family_members[selectedFamilyIndex];
      return {
        family_name: selectedMember?.full_name || "",
        family_phone: selectedMember?.phone_number || "",
        family_email: selectedMember?.email || "",
        family_unit_apt: selectedMember?.unit_apt ? `Unit ${selectedMember.unit_apt}` : "All Units",
      };
    }
    return {
      family_name: "",
      family_phone: "",
      family_email: "",
      family_unit_apt: "",
    };
  };

  return (
    <div>
      <Modal
        open={true}
        onClose={handleClose}
        title="View Details"
        maxWidth="675px"
        footer={
          <div className="flex w-full sm2:gap-4 gap-2 justify-end sm2:flex-row flex-col ">
            <ButtonComponent
              paddingY="10px"
              bgColor="#FFFFFF"
              color="#242424"
              onClick={handleClose}
            >
              Cancel
            </ButtonComponent>
            <ButtonComponent
              onClick={() => {
                setModalState("addProperty");
              }}
              paddingY="10px"
            >
              Edit Property Details
            </ButtonComponent>
            {["LANDLORD", "PROPERTY_MANAGER"].includes(userData?.accountType) && (
              <ButtonComponent
                onClick={() => setModalState("editTenant")}
                paddingY="10px"
              >
                Edit Tenant Details
              </ButtonComponent>
            )}
          </div>
        }
      >
        <div className=" border border-t-1 border-b-1 md:p-4 p-2">
          {" "}
          <div className="border-b">
            <div className="flex justify-between items-start">
              <div className="flex gap-4 items-center">
                <h3 className="font-medium text-[#242424]">
                  Property Information
                </h3>
              </div>
              <span
                className={`text-[12px]  px-3 py-1 border rounded-full font-medium text-[#3CAB5C] bg-[#F2FBF4] border-[#3CAB5C]`}
              >
                •{" "}
                {propertyData?.active_jobs?.length ||
                  propertyData?.active_jobs?.length ||
                  0}{" "}
                Active Jobs
              </span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4 py-4">
              {[
                { label: "Property Name", value: propertyData?.name },
                {
                  label: "Property Type",
                  value:
                    propertyData?.propertyType || propertyData?.property_type,
                },
                {
                  label: "Street Address",
                  value:
                    propertyData?.streetAddress || propertyData?.street_address,
                },
                { label: "City", value: propertyData?.city },
                {
                  label: "State",
                  value: propertyData?.state || propertyData?.state,
                },

                {
                  label: "ZIP",
                  value: propertyData?.zipCode || propertyData?.zip_code,
                },
              ].map((field, idx) => (
                <div key={idx}>
                  <span className="block text-[12px]  text-[#333333] font-[600] mb-1">
                    {field.label}:
                  </span>
                  <span className="block text-[14px] text-[#595959] font-[500] ">
                    {field.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
          {["LANDLORD", "PROPERTY_MANAGER"].includes(userData?.accountType) && (
            <div className="md:py-[40px] py-2">
              <div className="border-b pb-4 mb-4">
                <h3 className="font-medium text-[#242424] mb-4">
                  Tenant Information
                </h3>

                {propertyData?.tenants && propertyData?.tenants.length > 0 ? (
                  <Formik
                    initialValues={getInitialValues()}
                    enableReinitialize={true}
                    onSubmit={(values) => {}}
                  >
                    {({ errors, touched }) => (
                      <Form>
                        {/* Tenant Selector Dropdown */}
                        {propertyData?.tenants &&
                          propertyData?.tenants.length > 0 && (
                            <div className="mb-4">
                              <FormField
                                label="Tenant"
                                name="selectedTenant"
                                type="select"
                                showDefaultOption={false}
                                options={propertyData.tenants.map(
                                  (tenant, index) => ({
                                    value: index,
                                    label:
                                      tenant.full_name || ` ${index + 1}`,
                                  })
                                )}
                                onChange={(e) => handleTenantChange(e)}
                              />
                            </div>
                          )}

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                          {tenantFieldConfigPropertyDetails.map(
                            (field, fieldIndex) => (
                              <div key={fieldIndex} className="w-full">
                                <FormField
                                  label={field.label}
                                  name={`tenant_${field.name}`}
                                  type={field.type}
                                  placeholder={field.placeholder}
                                  disabled={true}
                                  error={errors[`tenant_${field.name}`]}
                                  touched={touched[`tenant_${field.name}`]}
                                />
                              </div>
                            )
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <div className="text-center py-8 text-[#595959]">
                    <p className="text-[16px] font-[500]">
                      No tenants found for this property
                    </p>
                    <p className="text-[14px] mt-2">
                      Tenants will appear here once they have joined.
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Family Members section: visible to HOMEOWNER and FAMILY_MEMBER */}
          {["HOMEOWNER", "STR_HOST", "FAMILY_MEMBER"].includes(userData?.accountType) && (
            <div className="md:py-[40px] py-2">
              <div className="border-b pb-4 mb-4">
                <h3 className="font-medium text-[#242424] mb-4">
                  Family Members
                </h3>
                {propertyData?.family_members &&
                propertyData?.family_members.length > 0 ? (
                  <Formik
                    initialValues={getFamilyInitialValues()}
                    enableReinitialize={true}
                    onSubmit={(values) => {}}
                  >
                    {({ errors, touched }) => (
                      <Form>
                        {/* Family Member Selector Dropdown */}
                        <div className="mb-4">
                          <FormField
                            label="Family Member"
                            name="selectedFamily"
                            type="select"
                            showDefaultOption={false}
                            options={propertyData.family_members.map(
                              (member, index) => ({
                                value: index,
                                label:
                                  member.full_name || `Member ${index + 1}`,
                              })
                            )}
                            onChange={(e) => handleFamilyChange(e)}
                          />
                        </div>

                        {/* Two columns on md+, one column on small screens */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {familyMemberFieldConfigPropertyDetails.map(
                            (field, fieldIndex) => (
                              <div key={fieldIndex} className="w-full">
                                <FormField
                                  label={field.label}
                                  name={`family_${field.name}`}
                                  type={field.type}
                                  placeholder={field.placeholder}
                                  disabled={true}
                                  error={errors[`family_${field.name}`]}
                                  touched={touched[`family_${field.name}`]}
                                />
                              </div>
                            )
                          )}
                        </div>
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <div className="text-center py-8 text-[#595959]">
                    <p className="text-[16px] font-[500]">
                      No family members found for this property
                    </p>
                    <p className="text-[14px] mt-2">
                      Family members will appear here once they are added
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}

          <div className="py-4  space-y-4">
            <h3 className="font-medium text-[#242424]">
              Active jobs at this property
            </h3>

            {propertyData?.active_jobs &&
            propertyData?.active_jobs.length > 0 ? (
              propertyData?.active_jobs.map((job, index) => (
                <div
                  key={index}
                  className=" bg-[#F8F8F8] rounded-[8px] p-3 justify-between  flex  flex-wrap gap-2 items-center"
                >
                  <div className="flex flex-col gap-2">
                    {" "}
                    <div className="flex gap-3 sm2:items-center sm2:flex-row flex-col">
                      <h4 className="text-[16px] font-[500] text-[#333333]">
                        {formatIssueAndSubIssue(job.issue_type, job.sub_issue_type)}
                      </h4>
                      <span
                        className={`text-xs px-3 border py-1 justify-center items-center flex gap-1 rounded-full font-medium ${
                          statusColors[job.status]
                        }`}
                      >
                        <span
                          className={`w-1 h-1 ${
                            statusDots[job.status]
                          } rounded-full`}
                        ></span>
                        {humanizeStatus(job.status)}
                      </span>
                    </div>
                    <div className="text-[14px] text-[#595959] font-[500] flex gap-4">
                      <p className="text-[14px]">
                        Requested on:{" "}
                        <span className="text-[#242424]">
                          {formatDate(job.created_at)}
                        </span>
                      </p>
                    </div>
                    {["LANDLORD", "PROPERTY_MANAGER"].includes(userData?.accountType) &&
                      job.tenant_info && (
                        <div className="flex items-center gap-2 bg-[#ECECEC] w-fit  px-3 py-1 rounded-full">
                          <span className="text-[12px] font-[500] text-[#333333] ">
                            Tenant: {job.tenant_info.full_name}
                          </span>
                        </div>
                      )}
                    {job.assigned_vendor_info?.full_name && (
                      <div className="flex items-center gap-2 bg-[#ECECEC] w-fit  px-3 py-1 rounded-full">
                        {/* <img
                          src={job.assigned_vendor_info?.full_name}
                          alt="avatar"
                          className="w-6 h-6 rounded-full object-cover"
                        /> */}
                        <span className="text-[12px] font-[500] text-[#333333] ">
                          {job.assigned_vendor_info?.full_name}
                        </span>
                      </div>
                    )}
                  </div>

                  <ButtonComponent
                    paddingY="8px"
                    bgColor="#FFFFFF"
                    color="#242424"
                    onClick={() => {
                      setCurrentSelectedData(job);
                      setModalState("manageJobs");
                    }}
                  >
                    Manage
                  </ButtonComponent>
                </div>
              ))
            ) : (
              <div className="text-center py-8 text-[#595959]">
                <p className="text-[16px] font-[500]">
                  No jobs found for this property
                </p>
                <p className="text-[14px] mt-2">
                  Jobs will appear here once they are created
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewDetails;
